import styled from 'styled-components';

import Heading from '../../../../components/Heading/Heading.styled';

export const ImageWrapperStyled = styled.div`
  text-align: center;
  margin-bottom: 26px;
`;

export const ImageStyled = styled.img`
  max-width: 345px;
  width: 100%;
`;

export const NoteStyled = styled.em`
  display: inline-block;
  margin-top: 40px;

  ${({ theme }) => `
    font-size: ${theme.fontSizes.xSmall};
    font-weight: ${theme.fontWeights.semibold};
  `}
`;

export const WayajSubTitleStyled = styled(Heading)`
  margin-bottom: 15px;
`;
